import { render, staticRenderFns } from "./NorticCheckbox.vue?vue&type=template&id=50cd25be&scoped=true&"
import script from "./NorticCheckbox.vue?vue&type=script&lang=js&"
export * from "./NorticCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./NorticCheckbox.vue?vue&type=style&index=0&id=50cd25be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cd25be",
  null
  
)

export default component.exports